import { atom } from 'jotai';

interface State {
  isOpen: boolean;
  isSubmitted: boolean;
}

export const forgottenPasswordDialogAtom = atom<State>({ isOpen: false, isSubmitted: false });
